import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as scheduleActions } from '../../../domain/useCases/schedule/getScheduleByDayUseCase';
import { Creators as procedureActions } from '../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as bannerListActions } from '../../../domain/useCases/externalSettings/getBannerList';
import { Creators as profileActions } from '../../../domain/useCases/getProfileTurn';
import { Creators as getPhotoActions } from '@/domain/useCases/getPhoto';
import { Creators as modalityActions } from '../../../domain/useCases/getModalityOfStudy';
import { Creators as linksActions } from '../../../domain/useCases/externalSettings/getLinksInterest';
import { Creators as ScheduleResumeHomeActions } from '../../../domain/useCases/schedule/getScheduleResumeHome';
import { Creators as externalSettings } from '../../../domain/useCases/externalSettings/getVersion';
import { dateNumberToString } from '../../reusables/Date/helpers';
import XCheckpointManager from '../../../core/managers/xcheckpointManager';
import useExternalSettings from '../../hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import HomeView from './HomeView';
import { useNewStudents } from '@/core/hooks/useNewStudents';
import { useNewLocations } from '@/presentation/hooks/useNewLocations';

const getNameForAnalytics = (testid: any) => {
  switch (testid) {
    case 'cmp-btn-alumnos-nuevos':
      return 'NewStudentsRoute';
    case 'cmp-btn-utp+class':
      return 'DigitalPlatformClass';
    case 'cmp-btn-utp+info':
      return 'DigitalPlatformInfo';
    case 'cmp-btn-biblioteca':
      return 'MightInterestLibrary';
    case 'cmp-btn-bolsa-trabajo':
      return 'MightInterestJobBoard';
    case 'cmp-btn-empleabilidad':
      return 'MightInterestEmployability';
    default:
      return '';
  }
};

export const handlerRedirectNewPage = (url: any, e?: any) => {
  const testId = e?.currentTarget.dataset.testid;
  const nameAnalitics = getNameForAnalytics(testId);
  GoogleAnalytics.writeLog(`portal-home-click${nameAnalitics}`, 'home');
  window.open(url, '_blank');
};

const HomeViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isNewLocation } = useNewLocations();
  const { data: dataExternalSettings } = useSelector(
    (state: any) => state.externalSettings
  );
  const { showPopup: showPopupEnrolmentTurn } = useSelector(
    (state: any) => state.profileTurn
  );

  const { data: dataVersion } = useSelector((state: any) => state.getVersion);

  const [loadStart, setLoadStart] = useState(false);
  const [openSchedule, setOpenSchedule] = useState(false);
  const [showButtonSchedule, setShowButtonSchedule] = useState(false);
  const { data: ScheduleResumeHome } = useSelector(
    (state: any) => state.getScheduleResumeHome
  );

  // selectors
  const { data, isCruce, isLoading } = useSelector(
    (state: any) => state.scheduleHome
  );
  const { data: interestLinks } = useSelector(
    (state: any) => state.interestLinks
  );
  // const profile = useSelector((state: any) => state.profile?.data?.profile); // ya no se usa profile porque no se lee el nombre
  /* comentario para retirar la modalidad  dispatch(modalityActions.getModalityOfStudy()); */
  const academic = useSelector((state: any) => state.profile?.data?.academic);
  const { data: dataModality } = useSelector(
    (state: any) => state.modalityOfStudy
  );

  const { data: dataBannerList } = useSelector(
    (state: any) => state.bannerList
  );

  const { data: dataProfileTurn } = useSelector(
    (state: any) => state.profileTurn
  );

  const { isEnrollmentTurn, currentPeriod, enrolmentPeriod, enroledInCurrent } =
    useExternalSettings();

  const { data: isNewStudent } = useSelector(
    (state: any) => state.getStudentType
  );

  const { data: studentPeriods } = useSelector(
    (state: any) => state.getPeriods
  );

  const newStudent = useNewStudents();

  useEffect(() => {
    XCheckpointManager.registerStart('Home logueado');
    if (!dataBannerList) dispatch(bannerListActions.getBannerList());
    /* comentario para retirar la modalidad  */
    dispatch(modalityActions.getModalityOfStudy());
    dispatch(linksActions.getLinksInterest());
    dispatch(externalSettings.getVersion());
    dispatch(getPhotoActions.getProfilePhoto());
    setLoadStart(true);
    GoogleAnalytics.writeLog('Menu-Inicio', 'Menu');
  }, []);

  useEffect(() => {
    if (academic && dataExternalSettings && currentPeriod) {
      const { portal_enable_exams: enabledExams } = dataExternalSettings;
      dispatch(
        scheduleActions.getScheduleByDay(
          new Date().getTime(),
          currentPeriod,
          enabledExams === 'true'
        )
      );
      dispatch(
        ScheduleResumeHomeActions.getScheduleResume(academic.periodDesc)
      );
    }
  }, [academic, dataExternalSettings, currentPeriod]);

  useEffect(() => {
    if (
      isEnrollmentTurn &&
      !dataProfileTurn?.enrolmentAppointment &&
      enroledInCurrent === false
    )
      dispatch(profileActions.getProfileTurn(enrolmentPeriod));
  }, [isEnrollmentTurn, enroledInCurrent]);

  useEffect(() => {
    if (
      data &&
      interestLinks &&
      dataModality &&
      ScheduleResumeHome &&
      dataBannerList &&
      ((isEnrollmentTurn && dataProfileTurn) || !isEnrollmentTurn) &&
      loadStart
    ) {
      XCheckpointManager.registerEnd('Home logueado');
      setLoadStart(false);
    }
  }, [
    data,
    interestLinks,
    dataModality,
    dataBannerList,
    dataProfileTurn,
    isEnrollmentTurn,
    ScheduleResumeHome
  ]);

  const getPeriodStudent = () => {
    const storedData = localStorage.getItem('profileData');
    let dataStudent: any;
    if (storedData) {
      dataStudent = JSON.parse(storedData);
    }
    return dataStudent;
  };

  useEffect(() => {
    const periodStudent = getPeriodStudent();
    if (periodStudent?.academic?.periodDesc === currentPeriod) {
      setShowButtonSchedule(true);
    }
  }, [dataExternalSettings]);

  const handlerRedirectBulletin = () => {
    const bulletinLink = interestLinks.find(
      (e: { name: string }) => e.name === 'Boletín'
    );
    window.open(bulletinLink.link, '_blank');
  };
  const handlerRedirectBenefit = () => {
    GoogleAnalytics.writeLog('portal-home-clickMightInterestBenefits', 'home');
    const benefitLink = interestLinks.find(
      (e: { name: string }) => e.name === 'Beneficio'
    );
    window.open(benefitLink.link, '_blank');
  };
  const DayAndMonth = {
    day: dateNumberToString(
      new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000,
      'small'
    )
  };

  const handlerRedirectPage = (url: string, procedure = false) => {
    if (procedure) {
      GoogleAnalytics.writeLog('portal-home-clickGoProcedure', 'home');
      dispatch(procedureActions.getProcedureInformation(1031));
    }
    GoogleAnalytics.writeLog(
      'portal-home-clickInstitutionalInformation',
      'home'
    );
    history.push(url);
  };

  const handlerHideEnrolmentTurn = () => {
    dispatch(profileActions.getProfileTurnHidePopup());
  };

  return (
    <HomeView
      data={data}
      dataVersion={dataVersion}
      handlerRedirectNewPage={handlerRedirectNewPage}
      handlerRedirectBulletin={handlerRedirectBulletin}
      handlerRedirectBenefit={handlerRedirectBenefit}
      handlerRedirectPage={handlerRedirectPage}
      name=""
      DayAndMonth={DayAndMonth}
      isCruce={isCruce}
      isLoading={isLoading}
      dataModality={dataModality}
      isPreg={academic?.career === 'PREG'}
      isNewStudent={isNewStudent}
      modalSchedule={{
        setOpenSchedule,
        openSchedule
      }}
      enrollmentProcessPeriod={dataExternalSettings?.enrollment_period_code}
      lastPeriodEnrolled={academic.periodDesc}
      numberOfPeriods={studentPeriods?.length}
      showButtonSchedule={showButtonSchedule}
      ScheduleResumeHome={ScheduleResumeHome}
      newStudent={newStudent}
      showPopupEnrolmentTurn={showPopupEnrolmentTurn}
      handlerHideEnrolmentTurn={handlerHideEnrolmentTurn}
      isNewLocation={isNewLocation}
    />
  );
};
export default HomeViewController;
